import telephoneCodes from "@/assets/json/telephone-codes.json";
import cloneDeep from "lodash-es/cloneDeep";

export function orderTelephoneCodes(codes = telephoneCodes) {
  const countryCodesToMoveToTop = ["GB", "US", "AU"];
  const ordered = cloneDeep(codes);

  return ordered
    .sort((a, b) => a.dial_code.localeCompare(b.dial_code))
    .sort((a, b) => {
      return countryCodesToMoveToTop.includes(a.code)
        ? -1
        : countryCodesToMoveToTop.includes(b.code)
        ? 1
        : 0;
    });
}

export function dialCodeForCountry(codes, countryCode) {
  if (!countryCode) {
    return null;
  }

  return codes.find((code) => code.code === countryCode)?.dial_code ?? null;
}

export function formatFullTelephoneNumber(dialCode, telephone) {
  if (!dialCode || telephone == null || telephone === "") {
    return null;
  }

  let nationalNumber = telephone.toString().trim();
  if (nationalNumber.startsWith("0")) {
    nationalNumber = nationalNumber.slice(1);
  }

  return `${dialCode}${nationalNumber}`;
}

/**
 * Country ISO code resolved by Shopify's localization for the current
 * session (geo-detected or user-selected within the market). Exposed on
 * window.shopifyMarket by shopify/layout/theme.liquid.
 */
export function getShopifyCountryCode() {
  return window.shopifyMarket?.country ?? null;
}

export async function fetchUserCountryCode() {
  const response = await fetch(
    "https://pro.ip-api.com/json?key=Y6SLxPFTt7gdeOe"
  );
  const data = await response.json();

  if (data.status === "fail" || !data.countryCode) {
    return null;
  }

  return data.countryCode;
}
